import React from 'react';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from 'react-redux';
import { enviarEncuesta } from '../../../store/actions/encuestas';

const useStyles = makeStyles({
  enviar: {
    width: 125,
    color: '#fff',
    backgroundImage: 'linear-gradient(45deg, rgb(251,176,64), rgb(241,90,41))',
    boxShadow: 'none',
    '&:hover': {
      filter: 'brightness(0.92)',
      boxShadow: 'none'
    }
  },
  disabled: {
    backgroundImage: 'none',
    backgroundColor: '#e0e0e0',
    color: '#777'
  }
});

const BotonEnviar = ({ respuestas, datosCrudos, habilitarBotonEnviar }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const hashEncuesta = useSelector((s) => s.encuestas.hashEncuesta);
  const envioFallido = useSelector((s) => s.encuestas.envioFallido);
  const detalleEnvio = useSelector((s) => s.encuestas.detalleEnvio);

  const handleEnviar = () => {
    dispatch(enviarEncuesta(respuestas, datosCrudos || '', hashEncuesta));
  };

  return (
    <div>
      {envioFallido === 1 && (
        <div>
          <p style={{ color: 'red' }}>Se produjo un error al enviar la respuesta:</p>
          <p>{detalleEnvio}</p>
        </div>
      )}
      <Button
        variant="contained"
        disableElevation
        className={classes.enviar}
        classes={{ disabled: classes.disabled }}
        disabled={!habilitarBotonEnviar}
        onClick={handleEnviar}
      >
        ENVIAR 🡅
      </Button>
    </div>
  );
};

export default BotonEnviar;
